module.exports = __webpack_public_path__ + "static/media/kildare.542e3acb.png";